import { AppLoader } from '@/components/feedback';

export const RouteLoader = () => <AppLoader variant="page" label="Loading BaptistOne" />;
